<template>
<moo-dialog custom-class="home-check-setting-common-dialog home-check-setting-dialog" :append-to-body="true" :visible.sync="visible" width="480px" :before-close="() => handleCheckDialog(false)">
    <div class="content">
      <div class="title">{{$t("发现重名文件（夹），请选择处理方式#!!!#src/pages/CloudHome/components/CheckDialog.vue_1")}}        <div class="close-btn" @click.stop="() => handleCheckDialog(false)">
          <svg-icon icon-class="file-transfer-close" class="close-icon"></svg-icon>
        </div>
      </div>
      <div class="tip">
        <svg-icon class-name="folder-icon" :icon-class="fileIcon"></svg-icon>
        {{ data.fileName }}
      </div>
      <div class="footer">
        <moo-button class="cancel" @click="visible = false">{{$t("取 消#!!!#src/pages/CloudHome/components/CheckDialog.vue_1")}}</moo-button>
        <moo-button class="cancel" @click="handleSaveAll">{{$t("保留两者#!!!#src/pages/CloudHome/components/CheckDialog.vue_1")}}</moo-button>
        <moo-button class="submit" type="primary" @click="handleReplace">{{$t("替换#!!!#src/pages/CloudHome/components/CheckDialog.vue_1")}}</moo-button>
      </div>
    </div>
  </moo-dialog>
</template>

<script>
import { fileImgName } from "@/utils/avatar";

export default {
  props: {},
  name: "CheckDialog",
  components: {},
  data() {
    return {
      visible: false,
      data: "",
    };
  },
  methods: {
    handleSaveAll() {
      if (this.data.type == "0") {
        this.$emit(
          "fileUploadChange",
          this.data.files,
          this.data.pid,
          "RENAME"
        );
      } else {
        // 修改files的webkitRelativePath，路径改为newFileName开头
        let files = this.data.files;
        const folderName = this.data.fileName;
        const newfolderName = this.data.newfolderName;
        files = files.map((file) => {
          const relativePath = file.webkitRelativePath;
          const newRelativePath = relativePath.replace(
            folderName,
            newfolderName
          );
          Object.defineProperty(file, "webkitRelativePath", {
            value: newRelativePath,
          });
          return file;
        });
        this.$emit(
          "folderUploadChange",
          files,
          this.data.pid,
          "RENAME"
        );
      }
      this.visible = false;
    },
    handleReplace() {
      if (this.data.type == "0") {
        this.$emit(
          "fileUploadChange",
          this.data.files,
          this.data.pid,
          "OVERWRITE"
        );
      } else {
        this.$emit(
          "folderUploadChange",
          this.data.files,
          this.data.pid,
          "OVERWRITE"
        );
      }
      this.visible = false;
    },
    handleCheckDialog(value, item) {
      this.visible = value;
      if (item) {
        this.data = item;
      }
    },
    getFileIcon(item) {
      const { fileName, type } = item;
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.substr(index).replace(".", "");
      return fileImgName(ext);
    },
  },
  computed: {
    fileIcon() {
      return this.getFileIcon(this.data);
    },
  },
  watch: {},
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss">
.home-check-setting-common-dialog {
  border-radius: 16px !important;
}

.home-check-setting-dialog {
    .moo-dialog__header {
        display: none !important;
    }
  .moo-dialog__body {
    padding: 0px !important;
    .content {
      display: flex;
      flex-flow: column;
      width: 100%;
      /* height: 480px; */
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;

      .title {
        width: 100%;
        height: 54px;
        font-family: "PingFang SC", sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #121317;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f1f4f5;
        padding: 0 24px;
        box-sizing: border-box;

        .close-btn {
          width: 24px;
          height: 24px;
          cursor: pointer;

          .close-icon {
            padding: 5px;
            width: 14px;
            height: 14px;
          }

          &:hover {
            background: #f4f6f9;
            border-radius: 4px;
          }
        }
      }

      .tip {
        padding: 24px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-flow: row;
        align-items: center;

        .folder-icon {
          width: 35px;
          height: 35px;
          margin-right: 8px;
        }
      }

      .footer {
        border-top: 1px solid #f1f4f5;
        padding: 10px 24px;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: flex-end;

        .cancel {
          outline: none;
          padding: 0;
          color: #222329;
          background: #fff;
          border: 1px solid #e8e9ee;
          font-size: 14px;
          font-weight: 400;
          height: 30px;
          width: 100px;
          border-radius: 4px;
        }

        .submit {
          outline: none;
          color: #fff;
          background: #5c70ff;
          border: none;
          box-shadow: inset -0.5px 0.5px rgba(0, 0, 0, 0.3),
            inset 0.5px -0.5px rgba(0, 0, 0, 0.3);
          font-size: 13px;
          font-weight: 400;
          padding: 0;
          height: 30px;
          width: 100px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
